$(function () {

    var $register = $('#register');

    if ($register.length === 0) {
        return;
    }

    var $slider = $register.find('.slider .tab-content'),
        windowWidth = $(window).width();

    $(window).resize(function () {
        windowWidth = $(window).width();
        slideDistance = $slider[0].scrollWidth - windowWidth + sidePadding;
    });

    // show/hide tab-content event
    $register.find('a.nav-link').not(".disabĺed").click(function () {
        if ($(this).hasClass('active') && $register.hasClass('show')) {
            $register.removeClass('show');
        } else {
            $register.addClass('show');
        }

        // reset scroll
        $slider.css('left', 0);
    });

    // move slider events
    var sidePadding = 16,
        slideStep = 200;

    var onLeft = function () {
        var $btn = $(this),
            slideDistance = $slider[0].scrollWidth - windowWidth + sidePadding;

        var newLeftPos;

        if ($slider.offset().left < -slideStep) {
            newLeftPos = $slider.offset().left + slideStep;
        } else {
            newLeftPos = 0;
        }

        $slider.css('left', newLeftPos);
    };

    var onRight = function () {
        var $btn = $(this),
            slideDistance = $slider[0].scrollWidth - windowWidth + sidePadding;

        var newLeftPos;

        if ($slider.offset().left > -(slideDistance - slideStep)) {
            newLeftPos = $slider.offset().left - slideStep;
        } else {
            newLeftPos = -slideDistance;
        }

        $slider.css('left', newLeftPos);
    };

    var timeout;

    $("#register .btn--left").on("vmousedown", function () {
        onLeft();
        timeout = ebusy.easingTimeout(250, 50, function () {
            onLeft();
        });
        return false;
    }).on("vmouseup", function () {
        if (timeout) {
            timeout.clear();
        }
        return false;
    }).on("vmouseout", function () {
        if (timeout) {
            timeout.clear();
        }
        return false;
    });

    $("#register .btn--right").on("vmousedown", function () {
        onRight();
        timeout = ebusy.easingTimeout(250, 50, function () {
            onRight();
        });
        return false;
    }).on("vmouseup", function () {
        timeout.clear();
        return false;
    }).on("vmouseout", function () {
        if (timeout) {
            timeout.clear();
        }
        return false;
    });

    var isSimpleCard = false;
    var isSpecialCard = false;

    $("#register .register-card").on("dragstart", function (event) {

        var $card = $('<div>', {
            "class": "register-card register-card-clone text-color-primary",
            "css": {
                "position": "absolute",
                "top": "-300px"
            }
        });

        var cardBody = event.target;
        var cardBodyClientRect = cardBody.getBoundingClientRect();
        var offsetX = event.clientX - cardBodyClientRect.left;
        var offsetY = event.clientY - cardBodyClientRect.top;

        $card.append($(cardBody).clone());
        $("body").append($card);

        var dataTransfer = event.originalEvent.dataTransfer;

        if (dataTransfer.setDragImage !== undefined) {
            dataTransfer.setDragImage($card.get(0), offsetX, offsetY);
        }

        dataTransfer.effectAllowed = "move";

        var dragData = {};

        var userId = $(cardBody).parent().data('user-id');
        if (userId !== undefined) {
            dragData.userId = userId;
            isSimpleCard = true;
        }

        var bookingTypeId = $(cardBody).parent().data('booking-type-id');
        if (bookingTypeId !== undefined) {
            dragData.bookingTypeId = bookingTypeId;
            isSpecialCard = true;
        }

        dataTransfer.setData("text/plain", JSON.stringify(dragData));

        $register.removeClass("show");
        $slider.css("left", 0);

        if (isSimpleCard) {
            $(".reservation").each(function () {

                var icon = $(this).hasClass("not-complete") ? 'plus-circle' : 'lock';

                if ($(this).find(".card span:visible").length) {
                    $(".card span:first", $(this)).append("<span class='text-color-primary participate-label icon-" + icon + "'></span>");
                } else {
                    $(".reservation-content", $(this)).append("<span class='text-color-primary participate-label icon-" + icon + "'></span>");
                }
            });
        }
    });

    $(".slot, .reservation")
        .on("dragenter", function (event) {

            if (!isSimpleCard && !isSpecialCard) {
                return;
            }

            $("span.card.background-color-primary").removeClass("card").removeClass("background-color-primary");
            $(this).find(".slot-label span").addClass("card").addClass("background-color-primary");
        })
        .on("dragover", function (event) {
            event.originalEvent.dataTransfer.dropEffect = "move";
            event.preventDefault();
        })
        .on("drop", function (event) {

            event.preventDefault();

            if (!isSimpleCard && !isSpecialCard) {
                return;
            }

            $(".register-card-clone").remove();
            $(".slot-label span").removeClass("card").removeClass("background-color-primary");
            $(".reservation-content .participate-label").remove();

            var dataTransfer = event.originalEvent.dataTransfer;
            var dragData = JSON.parse(dataTransfer.getData("text"));

            if ($(this).hasClass("reservation")) {

                if (isSimpleCard && $(this).hasClass("not-complete")) {
                    addParticipantCard($(this), dragData.userId);
                }

                isSimpleCard = false;
                isSpecialCard = false;
                return;
            }

            if (isSimpleCard || isSpecialCard) {
                ebusy.startBookingFlow($(this), ebusy.lite, dragData.userId, dragData.bookingTypeId);
            }

            isSimpleCard = false;
            isSpecialCard = false;
        });

    function addParticipantCard(slot, userId) {

        var url = ebusy.lite.bookingsUrl + "/" + slot.data("booking-id") + "/add-participant-card?user=" + userId;

        $.get(url, function(data) {
            $("#modal").html(data).modal();
            $(document).trigger("modal.load");
        });
    }

    $(document).on("dragend", function (event) {

        if (!isSimpleCard && !isSpecialCard) {
            return;
        }

        event.preventDefault();

        $(".register-card-clone").remove();
        $(".slot-label span").removeClass("card").removeClass("background-color-primary");
        $(".reservation-content .participate-label").remove();

        isSimpleCard = false;
        isSpecialCard = false;
    });

});
